import React from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';

function ButtonLink(props) {
    let buttonClasses = classNames('btn-link', props.className);

    return (
        <ButtonBase {...props} className={buttonClasses}/>
    );
}

ButtonLink.propTypes = {
    ...ButtonBase.propTypes
};

ButtonLink.defaultProps = {
    ...ButtonBase.defaultProps
};

export default ButtonLink;
